import { toast } from "react-toastify";
import requestUtil from "../../helpers/requestUtil";
import {
  formReset,
  setClearData,
  setEditDetailsForm,
  setLevel,
  setLoadingFlagDecrement,
  setLoadingFlagIncrement,
  setSampleData,
} from "./slice";

// get Location List in dropdown
export function getLocationLists(baseUrl, empuniqueId) {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(
        `${baseUrl}/Locations/get-location-list-for-dropdown/${empuniqueId}`,
        "GET"
      );
      return response;
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

// Page Refersh form
export const FormResetData = () => {
  return async (dispatch) => {
    dispatch(formReset());
  };
};

// Clear data for Teams Search Results Table
export const clearTeamsFilterListData = () => {
  return async (dispatch) => {
    dispatch(setClearData());
  };
};

// Create Team API CALL
export function createTeamsListSave(baseUrl, params, flag) {
  return async (dispatch) => {
    try {
      dispatch(setLoadingFlagIncrement());
      const response = await requestUtil(`${baseUrl}`, "POST", { ...params });
      toast.success(
        flag ? "Team Created  Successfully!" : "Team Updated  Successfully!"
      );
      return response;
    } catch (error) {
      toast.error("Team Name Already Exist!");
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

// get Edit details
export const getDetailsEditForm = (
  editFormPayload,
  filteredLevel,
  filterDepartment
) => {

  return async (dispatch) => {
    const params = {
      locationName: editFormPayload.locationid,
      teamName: editFormPayload.teamName,
      isActive: editFormPayload.isActive,
      level: filteredLevel,
      departmentList :filterDepartment
    };
    console.log(params);
    dispatch(setEditDetailsForm(params));
  };
};

// Sample render data
export function getTeamFilterLists(baseUrl, params) {
  return async (dispatch) => {
    try {
      dispatch(setLoadingFlagIncrement());
      const response = await requestUtil(
        `${baseUrl}/TeamScheduling/search-candidate`,
        "POST",
        { ...params }
      );
      dispatch(setSampleData(response));
    } catch (error) {
      dispatch(setSampleData([]));
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

// get Teams Listing Page
export function getTeamListingDetails(baseUrl, LocationId) {
  return async (dispatch) => {
    try {
      dispatch(setLoadingFlagIncrement());
      const response = await requestUtil(
        `${baseUrl}/TeamScheduling/get-teams-by-location?Locationid=${LocationId}`,
        "GET"
      );
      return response;
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

// delete for Single Candiate Team member
export function deleteSingleAndGroupTeamListingDetails(baseUrl, flag) {
  return async (dispatch) => {
    try {
      dispatch(setLoadingFlagIncrement());
      const response = await requestUtil(`${baseUrl}`, "DELETE");
      toast.success(
        flag
          ? "Team deleted successfully!"
          : "Candidate is removed from this team successfully!"
      );
      return response;
    } catch (error) {
      toast.error("Data Not Found");
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

function groupByDropDownFormat(requestArray) {
  const newArray = [];
  if (requestArray && requestArray.length) {
    for (let index = 0; index < requestArray.length; index++) {
      const element = requestArray[index];
      const groupByLabel = element.label;
      const newOptions = element.options.map((e) => {
        return {
          ...e,
          groupByLabel,
        };
      });
      newArray.push(...newOptions);
    }
  }
  return newArray;
}

// Sample render data
export function getLevel(baseUrl, jobtypes) {
  return async (dispatch) => {
    try {
      dispatch(setLoadingFlagIncrement());
      // const params = {
      //   jobtypes: [1, 3, 4],
      // };
      const response = await requestUtil(
        `${baseUrl}/Employers/get-job-categories`,
        "POST",
        { jobtypes }
      );
      const groupByDropDownResult = groupByDropDownFormat(
        response.groupedOption
      );
      dispatch(setLevel(groupByDropDownResult));
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}
